var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"location"},[_vm._v(_vm._s(_vm.lat)),_c('br'),_vm._v(_vm._s(_vm.lng))])
}
var staticRenderFns = []

export { render, staticRenderFns }